export default __webpack_public_path__ + "static/silent_trio-1563b54c6edd853a695d694b77155ba2.png";